import * as React from "react";
import type { SVGProps } from "react";

/**
 * Invite Icon - 邀请/推广图标
 * Used for: Affiliate/Invite category
 */
const InviteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 48 48"
    {...props}
    fill={"currentColor"}
    fillRule={"evenodd"}
    stroke={"transparent"}
    className={"cus-svg"}
  >
    <path
      d="M38.5 20.781a11.709 11.709 0 0 0-10.448 6.43A35.617 35.617 0 0 1 20.5 28C10.283 28 2 23.971 2 19v-6h.121C3.144 8.5 10.978 5 20.5 5s17.356 3.5 18.38 8H39v6a4.643 4.643 0 0 1-.368 1.787c-.044 0-.087-.006-.132-.006Zm-17.166-4.724a3.651 3.651 0 0 0 1.578-.535.847.847 0 0 0 .391-.7 1 1 0 0 0-.567-.7 6.1 6.1 0 0 0-1.445-.614ZM5 13.5c0 3.354 6.059 6.113 13.837 6.461l.063-1.95a.139.139 0 0 0-.056-.02h-.057a10.174 10.174 0 0 1-4.22-.883 2.177 2.177 0 0 1-1.549-2.4.42.42 0 0 1 .036-.111.5.5 0 0 0 .038-.127.472.472 0 0 1 .038-.126.429.429 0 0 0 .035-.109H17.3a1.6 1.6 0 0 0 .288 1.3 4.2 4.2 0 0 0 1.883.518l.06-2.769a15.954 15.954 0 0 1-4.075-1.146 3.176 3.176 0 0 1-1.614-1.333.935.935 0 0 1-.1-.3.984.984 0 0 1 0-.307A2.668 2.668 0 0 1 15.589 8.5a9 9 0 0 1 3.642-.708l.025-.761C11.279 7.293 5 10.086 5 13.5Zm13.8-4.324a1.047 1.047 0 0 0-.495.212.567.567 0 0 0-.389.194.648.648 0 0 0-.081.278.758.758 0 0 0 .361.651 3.239 3.239 0 0 0 1.392.455l.04-1.856a4.338 4.338 0 0 0-.828.066ZM20.5 7h-.164.327-.163Zm1.089.023.022.764a9.9 9.9 0 0 1 3.536.619 2.524 2.524 0 0 1 1.879 1.84h-4a1.029 1.029 0 0 0-.426-.758 2.575 2.575 0 0 0-1.39-.378l.038 2.161a16.281 16.281 0 0 1 4.212 1.138 5.657 5.657 0 0 1 2.182 1.56 2.218 2.218 0 0 1 .223.408 1.882 1.882 0 0 1 .12.415c.13.8-.333 1.531-1.412 2.184a9.072 9.072 0 0 1-4.673 1.015l.056 1.978C29.833 19.661 36 16.884 36 13.5c0-3.436-6.361-6.242-14.411-6.477ZM2 21.469V21h.052a3.972 3.972 0 0 0-.052.469ZM20.5 30a38.178 38.178 0 0 0 6.7-.584 11.4 11.4 0 0 0-.05 5.974 36.128 36.128 0 0 1-6.65.61C10.283 36 2 31.971 2 27v-5.469C2.037 26.211 10.3 30 20.5 30ZM2 29.469V29h.052a3.972 3.972 0 0 0-.052.469ZM20.5 38a37.854 37.854 0 0 0 7.319-.694 11.755 11.755 0 0 0 3.988 4.807A32.592 32.592 0 0 1 20.5 44C10.283 44 2 39.971 2 35v-5.469C2.037 34.211 10.3 38 20.5 38ZM46 35h-5v5a2 2 0 0 1-4 0v-5h-5a2 2 0 0 1 0-4h5v-5a2 2 0 0 1 4 0v5h5a2 2 0 0 1 0 4Z"
      data-name="矩形 2636"
    />
  </svg>
);

export default InviteIcon;

